<template>
  <a
    v-if="url && label"
    @click="registerEvent"
    :href="url"
    :alt="alt"
    :class="{
      'c-btn--primary': buttonType === 'primary',
      'c-btn--secondary': buttonType === 'secondary',
      'c-btn--tertiary': buttonType === 'tertiary',
    }"
    :target="linkTarget"
    class="c-btn c-btn--margins"
    tabindex="0"
  >
    {{ label }}
  </a>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'primary',
    },
    linkTarget: {
      type: String,
      default: '_self',
    },
  },
  methods: {
    registerEvent(event) {
      this.$gtag.event(`Knapp: ${this.label}`, {
        event_category: 'Button',
        event_label: event,
      });
    },
  },
};
</script>
